import makeStyles from '@material-ui/core/styles/makeStyles';

const styles = makeStyles((theme) => ({
  accordion: {
    padding: '0.5rem',
    marginTop: '12px !important',
    borderRadius: '0 !important',
  },
  accordionSummary: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  accordionSummaryContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  errorIcon: {
    fontSize: 16,
  },
  status: {
    fontSize: 14,
    fontWeight: 500,
    '&.active': {
      color: '#4CAF50',
    },
    '&.failing': {
      color: theme.palette.error.main,
      fontWeight: 600,
    },
    '&.paused': {
      color: '#039BE5',
    },
  },
  date: {
    fontSize: 12,
  },
  url: {
    fontSize: 14,
    display: 'flex',
    alignItems: 'center',
    gap: 8,

    '& .MuiIconButton-root': {
      fontSize: 16,
      marginLeft: 8,
      cursor: 'pointer',
    },

    '& svg': {
      width: 20,
    },
  },
  type: {
    fontSize: 14,
  },
  filter: {},
  notFound: {
    textAlign: 'center',
    padding: 24,
    marginTop: 12,
  },
  filterHistory: {
    margin: 12,
  },
  filterHistoryExpanded: {
    padding: '32px !important',
    marginTop: 12,
    marginBottom: 24,
    background: '#f9f9f9',
  },
  invoice: {
    '&.paid, &.negociated': {
      color: '#4CAF50',
    },
    '&.refunded, &.waiting_refund': {
      color: theme.palette.error.main,
    },
    '&.canceled, &.duplicated, &.expired': {
      color: '#37474F',
    },
    '&.open, &.waiting_payment': {
      color: '#039BE5',
    },
    '&.analysing': {
      color: '#2d86ca',
    },
    '&.recovering': {
      color: '#fabb0a',
    },
  },
  subscription: {},
  description: {
    wordBreak: 'break-word',
  },
  historic: {
    marginTop: 24,
    '& .title': {
      fontSize: 18,
      fontWeight: 600,
    },
    '& .not-found': {
      width: '100%',
      textAlign: 'center',
      padding: '24px 0',
      fontSize: 14,
      color: theme.palette.primary.light,
    },

    '& .table': {},
  },

  data: {
    marginTop: '24px',

    '& .MuiSvgIcon-root-569': {
      fontSize: 18,
      marginLeft: 8,
      cursor: 'pointer',
    },

    '& .title': {
      fontSize: 18,
      fontWeight: 600,
    },

    '& pre': {
      margin: 0,
      fontSize: 13,
      width: '100%',
      overflow: 'auto',
      background: theme.palette.grey[100],
      padding: 8,
      borderRadius: 4,
      marginTop: 8,
    },
  },
  documentationButton: {
    marginRight: 12,
  },

  httpStatus: {
    color: '#ffff',
    padding: '3px 6px',

    '&.status-failed': {
      backgroundColor: theme.palette.error.dark,
    },

    '&.status-success': {
      backgroundColor: theme.palette.success.dark,
    },
  },
  rowError: {
    background: 'rgba(251, 235, 237, 0.55)',
  },
  rowPending: {
    background: 'rgba(245, 223, 134, 0.15)',
  },
  listHistoryAction: {
    minWidth: 32,
  },
  webhookStatus: {
    background: theme.palette.grey[200],
    padding: '3px 6px',
    fontSize: 13,
    fontWeight: 600,

    '&.--status-success': {
      background: theme.palette.success.dark,
      color: '#fff',
    },

    '&.--status-failed': {
      background: theme.palette.error.dark,
      color: '#fff',
    },
  },
  filterButtonsWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 12,
  },
}));

export default styles;
